import { WithRef } from '../../../types';
import IconBase, { CastProductIconProps } from '../IconBase';

export const CastCopilot = ({
  ref,
  ...props
}: WithRef<SVGSVGElement, Omit<CastProductIconProps, 'variant'>>) => {
  const color = props.color ?? '#fff';
  return (
    <IconBase
      ref={ref}
      {...props}
      color={color}
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.967 2.033a.106.106 0 0 0-.137-.014l-1.029.68a8.71 8.71 0 0 1-9.602 0l-1.03-.68c-.098-.065-.215.052-.15.15l.68 1.03a8.71 8.71 0 0 1 0 9.602l-.68 1.03c-.065.098.052.215.15.15l1.03-.68a8.71 8.71 0 0 1 9.602 0l1.03.68c.098.065.215-.052.15-.15l-.68-1.03a8.7 8.7 0 0 1-1.4-5.647 15.1 15.1 0 0 0-7.046 3.99z"
        fill={color}
      />
    </IconBase>
  );
};

CastCopilot.displayName = 'CastCopilot';
